import React from "react";

export default function CategoryHeader({
	label,
	count,
	countLabel,
	color,
	bgColor,
	loading,
	style,
}) {
	return (
		<div className="category-header" style={style}>
			<div className="category-header-accent" style={{ background: color }} />
				<span className="category-header-label">{label}</span>

				{loading ? (
					<span className="stats-loading">
						<div className="spinner" style={{ width: '14px', height: '14px' }}></div>
					</span>
				) : (
					<span className="category-header-count" style={{ color, background: bgColor }}>
					{count?.toLocaleString()} {countLabel}
					</span>
				)}

			<div className="category-header-line" />
		</div>
	);
}